export default function GlobalLoadingIndicatorServiceProvider() {
  this.$get = () => {
    'ngInject';

    function GlobalLoadingIndicatorService() {

      const self = this;
      const handlers = [];

      self.registerHandler = (id, handler) => {
        handlers.push({id: id, handler: handler});
      }

      self.unregisterHandler = (id) => {
        for (let i = 0; i < handlers.length; i++) {
          if (handlers[i].id === id) {
            handlers.splice(i, 1);
          }
        }
      };

      self.show = () => handlers.forEach(handler => handler.handler.show());

      self.hide = () => handlers.forEach(handler => handler.handler.hide());

    }

    return new GlobalLoadingIndicatorService();
  };
}